<div tabindex="0" class="me-package" *ngIf="data && bexioData && bexioData['id']">
    <div class="me-package__header">
        <div class="me-package__header__percentoff" *ngIf="data.discount && data.discount != 0">
            {{data.discount}}% {{ 'off' | translate}}
        </div>
        <div class="me-package__header__priceText">{{header || data.priceText}}</div>
        <div class="me-package__header__title">{{data.title}}</div>
        <div class="me-package__header__price">
            <span class="me-package__header__price__sale" *ngIf="salePrice">
                {{formatSalePrice}}
            </span>
            <span>
                {{formatPrice}}
            </span>
        </div>
    </div>
    <div class="me-package__body">
        <div class="me-package__body__image" *ngIf="data.image">
            <img src="{{data.image.filename}}">
        </div>
        <div class="me-package__body__text" [innerHTML]="data.body | storyblokRichtext"></div>
    </div>
    <div class="me-package__button">
        <button class="btn btn--primary w-100" (click)="choosePackage()">
            {{'Choose package' | translate}}
        </button>
    </div>
</div>